import {
  Laptop, Monitor, Smartphone, Backpack, Armchair, Router,
  KeyRound, PhoneCall, Mouse, Cpu, Plug, Package, type LucideIcon,
} from "lucide-react";

const ICON_RULES: [RegExp, LucideIcon][] = [
  [/LAPTOP/, Laptop],
  [/DESKTOP/, Cpu],
  [/MONITOR|SCREEN/, Monitor],
  [/MOBILE|PHONE/, Smartphone],
  [/BAG|BACKPACK|CASE/, Backpack],
  [/CHAIR|DESK|FURNITURE|SOFA/, Armchair],
  [/NETWORK/, Router],
  [/SOFTWARE|LICENSE/, KeyRound],
  [/TELECOM|SIM/, PhoneCall],
  [/PERIPHERAL|MOUSE|KEYBOARD/, Mouse],
  [/ELECTRONIC/, Plug],
];

export function getCategoryIcon(value: string): LucideIcon {
  const match = ICON_RULES.find(([pattern]) => pattern.test(value.toUpperCase()));
  return match ? match[1] : Package;
}
